<template>
  <div class="key-add-dialog">
    <div class="content">
      <el-form :model="ruleForm" :hide-required-asterisk="false" label-width="120px" size="large" label-position="top" ref="ruleForm" @submit.native.prevent :rules="rules">
        <el-form-item label="字段名称" prop="component_name_in_template">
          <el-input v-model="ruleForm.component_name_in_template" placeholder="请输入字段名称" maxlength="20" clearable></el-input>
        </el-form-item>
        <el-form-item label="字段类型" prop="component_code">
          <el-select v-model="ruleForm.component_code" placeholder="请选择" @change="slelectTemp" :disabled="isEdit" popper-class="key-select-o" class="key-select-o-p">
            <template #prefix>
              <span>
                <i class="icon iconfont" :class="keyIcon[ruleForm.component_code] || 'iconicon_custom_field'"></i>
              </span>
            </template>
            <el-option v-for="item in templateConfig" :key="item.code" :label="item.standard_component_name" :value="item.code">
              <span>
                <i class="icon iconfont" :class="keyIcon[item.code] || 'iconicon_custom_field'"></i>
                {{item.standard_component_name}}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="component_desc_in_template">
          <el-input v-model="ruleForm.component_desc_in_template" placeholder="请输入" maxlength="100" clearable></el-input>
        </el-form-item>
        <div v-for="(item) in configParams" :key="item.attribute_name">
          <el-form-item :label="item.attribute_desc + '：'" :prop="item.attribute_name" v-if="item.attribute_name !== 'is_require' && item.attribute_name !== 'default_value_range'">
            <component v-model="item.value" @input="comValueChange(item.attribute_name,item.value)" :is="item.attribute_name" :projectId="projectId"></component>
          </el-form-item>
          <div v-if="item.attribute_name === 'default_value_range'">
            <component v-model="item.value" :isEdit="isEdit" @input="comValueChange(item.attribute_name,item.value)" :is="item.attribute_name" :projectId="projectId"></component>
          </div>
        </div>
      </el-form>
    </div>
    <div class="footer-btns">
      <div>
        <span v-if="ruleForm.component_code.indexOf('Number') > -1 && ruleForm.component_code.indexOf('Percentage') > -1">
          <span>预览：100</span>
          <span v-if="config.decimal_places > 0">.</span>
          <span v-for="(item,index) in config.decimal_places" :key="index">0</span>
          <span>%</span>
        </span>
        <span v-else-if="ruleForm.component_code.indexOf('Number') > -1">
          <span>预览：1,000</span>
          <span v-if="config.decimal_places > 0">.</span>
          <span v-for="(item,index) in config.decimal_places" :key="index">0</span>
          {{config.currency}}
        </span>
      </div>
      <div>
        <span class="cancel text-btn-active" @click="$emit('cancel')" style="margin-right: 24px;">取消</span>
        <wf-button type="primary" @click="submitForm" :loading="btnLoading">确 定</wf-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import store from '@/store';
let templateConfig = store.state['customKey/customKey'].templateConfig
import customService from '@/services/api/customKey/customKey'
export default {
  props: {
    editData: {
      type: Object,
      default: () => { }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [Number, String]
    },
  },
  components: {

  },
  data() {
    return {
      ruleForm: {
        component_name_in_template: '',
        component_code: '',
        component_desc_in_template: ''
      },
      rules: {
        component_name_in_template: [{ required: true, trigger: 'change', message: '此项不能为空' }],
        component_code: [{ required: true, trigger: 'change', message: '此项不能为空' }],
        // component_desc_in_template: [{ required: true, trigger: 'change', message: '此项不能为空' }]
      },
      config: {},
      configRules: {},
      configParams: [],
      btnLoading: false,
      value: ''
    }
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible) {
          this.init()
        }
      },
      deep: true
    },
  },
  created() {
    this.init()
  },
  computed: {
    ...mapState('customKey/customKey', {
      templateConfig: state => state.templateConfig
    }),
    ...mapState('template/template', {
      templateData: state => state.dataset
    }),
  },
  methods: {
    ...mapActions('customKey/customKey', ['updateKey']),
    init() {
      // this.getCOmponent()
      if (!this.isEdit) {
        Object.assign(this.$data, this.$options.data());
      } else {
        this.config = JSON.parse(JSON.stringify(this.editData.component_config_in_template))
        this.slelectTemp(this.editData.component_code)
        this.ruleForm.component_name_in_template = this.editData.component_name_in_template
        this.ruleForm.component_code = this.editData.component_code
        this.ruleForm.component_desc_in_template = this.editData.component_desc_in_template
        let item = this.templateConfig[this.editData.component_code].config
        item.forEach(res => {
          this.configRules[res.attribute_name] = [{ required: true, trigger: 'change', message: '此项不能为空' }]
          this.config[res.attribute_name] = this.editData.component_config_in_template[res.attribute_name]
          if (res.attribute_name === 'is_require') {
            this.config[res.attribute_name] = false
          }
        })
        let arr = JSON.parse(JSON.stringify(item))
        arr.forEach(res => {
          res.value = this.editData.component_config_in_template[res.attribute_name]
        })
        this.configParams = JSON.parse(JSON.stringify(arr))
      }
    },
    getCOmponent() {
      customService.getAllComponent({ number: 999, page: 1 }).then(res => {
        this.options = res.data
      })
    },
    getInputType() {
      return this.options.find(res => res.type === this.ruleForm.component_code) || ''
    },
    changeValue(data) {
      this.config.default_value_range = JSON.parse(JSON.stringify(data))
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = { ...this.ruleForm }
          let config = { ...this.config }
          let result = {
            ...this.ruleForm,
            component_config_in_template: {
              ...this.config
            }
          }
          let flg = this.templateData?.task_template_content?.template_standard_components.find(res => res.component_code === result.component_code && res.component_name_in_template === result.component_name_in_template)
          if(this.isEdit ? flg && this.editData.sort !== flg.sort : flg) {
            this.$message({
              message: `【${flg?.component_name_in_template}】该类型的字段名称已存在，请换一个字段名称或类型`,
              type: 'warning'
            })
            return
          }
          this.$emit('change', result, this.isEdit)
        }
      })
    },
    slelectTemp(val) {
      this.value = ''
      this.config = {}
      this.configRules = {}
      this.configParams = []
      let item = this.templateConfig[val].config
      item.forEach((res, index) => {
        this.config[res.attribute_name] = ''
        this.configRules[res.attribute_name] = [{ required: true, trigger: 'change', message: '此项不能为空' }]
        if (res.attribute_name === 'is_require') {
          this.config[res.attribute_name] = false
        }
      })
      this.configParams = JSON.parse(JSON.stringify(item))
    },
    comValueChange(key, val) {
      this.config[key] = val
    },
  }
}
</script>
<style lang="scss">
.key-select-o {
  .el-select-dropdown__item {
    font-size: 14px;
    i {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.8);
      margin-right: 16px;
    }
  }
}
.key-add-dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .select-link-preview {
    cursor: pointer;
    text-decoration: underline;
    color: #509aff;
  }
  .el-select {
    width: 100%;
  }
  .key-select-o-p {
    .el-input__prefix {
      i {
        font-size: 14px;
        color: rgba(32, 32, 32, 0.8);
      }
    }
    .el-input--prefix .el-input__inner {
      padding-left: 44px;
    }
  }
}
</style>
